import Raven from '../Raven';

export const getRemoteStorage = (key) => {
    return Raven.get(`remoteStorage/data/${key}`)
}

export const setRemoteStorage = (key, data) => {
    const result = Raven.post(
        `remoteStorage/data/${key}`,
        data,
        {
            'headers': {
                'Content-Type': 'application/json'
            }
        }
    )

    return result
}

export const deleteRemoteStorage = (key) => {
    return Raven.delete(`remoteStorage/data/${key}`)
}

export const getRemoteNotification = (baID, countryCode3) => {
    return Raven.get(`remoteStorage/data/notification-${baID}-${countryCode3}`)
}

export const setRemoteNotification = (baID, countryCode3, data) => {
    return Raven.post(
        `remoteStorage/data/notification-${baID}-${countryCode3}`,
        data,
        {
            'headers': {
                'Content-Type': 'application/json'
            }
        }
    )
}

export const deleteRemoteNotification = (baID, countryCode3) => {
    return Raven.delete(`remoteStorage/data/notification-${baID}-${countryCode3}`)
}